<template>
  <div>
    <div class="page page__list" v-if="!isSj">
      <search-bar
        @search="onSearch"
        name="qu_code,qu_custname,qu_remark"
        placeholder="输入单据编号、客户、备注进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="(item, index) in items"
          :key="index"
          :to="'/sale/quote/' + item.qu_id"
        >
          <div class="weui-cell__bd">
            <p>{{ item.qu_custname }}</p>
            <p class="list-item-muted">{{ item.qu_date }}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{ item.qu_code }}</p>
            <p>{{ item.qu_seller }}</p>
            <span
              class="list-item-status"
              :class="{ warning: item.qu_status != '已审核' }"
              >{{ item.qu_status }}</span
            >
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{ items.length }}次</label>
      </div>
    </div>

    <div class="page page__list" v-if="isSj">
      <search-bar
        @search="onSearch"
        placeholder="输入物料名称、规格进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <div
          class="weui-cell weui-cell_access"
          v-for="(item, index) in items"
          :key="index"
          @click="gotoView(item)"
        >
          <div class="weui-cell__bd">
            <p>{{ item.custName }}</p>
            <p class="list-item-muted">{{ item.inquiryCode }}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{ item.prodName }}</p>
            <span
              class="list-item-status"
              :class="{ warning: item.quoted == 10 }"
              v-if="item.quoted == 10"
            >
              待报价
            </span>
            <span
              class="list-item-status"
              :class="{ warning: item.quoted == 10 }"
              v-if="item.quoted == 20"
            >
              待采纳
            </span>
            <span
              class="list-item-status"
              :class="{ warning: item.quoted == 10 }"
              v-if="item.quoted == 30"
            >
              已采纳
            </span>
            <span
              class="list-item-status"
              :class="{ warning: item.quoted == 10 }"
              v-if="item.quoted == 40"
            >
              未采纳
            </span>
            <span
              class="list-item-status"
              :class="{ warning: item.quoted == 10 }"
              v-if="item.quoted == 50"
            >
              已失效
            </span>
          </div>
        </div>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">待报价：{{ getDaiBaoJiaNum }}次</label>
      </div>
    </div>
    <add-button to="/sale/quote_edit" />
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton,
  },
  mixins: [list],
  data() {
    const me = this,
      beforeChange = me.beforeFilterChange;
    return {
      isSj: true,
      listUrl: "/api/sale/quotation/list",
      filters: [
        {
          type: "date",
          value: 4,
          name: "qu_date",
        },
        {
          type: "condition",
          label: "状态",
          value: 1,
          beforeChange,
          options: [
            {
              value: -1,
              label: "全部",
              mode: "DETAIL",
            },
            {
              value: 1,
              label: "平台商机",
            },
            {
              value: 2,
              label: "待报价",
              condition: "qu_statuscode != 'AUDITED'",
              mode: "DETAIL",
            },
            {
              value: 3,
              label: "已报价",
              condition: "qu_statuscode ='AUDITED'",
              mode: "DETAIL",
            },
          ],
        },
      ],
    };
  },
  computed: {
    getDaiBaoJiaNum() {
      const items = this.items

      let num = 0

      items.forEach(item => {
        if(item.quoted == 10) num++
      })

      return num
    }
  },
  methods: {
    beforeFilterChange(filter, filterBar, next) {
      this.isSj = filter.value == 1;
      this.params.number = 1
      // filterBar.initConfig();
      next();
    },
    onSearch(callback, next) {
      var callbackFn = typeof callback === "function" ? callback : null;
      if (this.isSj) {
        this.searchSj(callbackFn, next);
        return;
      }
      this.doSearch(callbackFn, next);
    },
    searchSj(callback, next) {
      let me = this;
      let number = (next && me.items.length) ? me.params.number + 1 : 1;
      let keyword = me.$refs.searchBar.getValue();
      let filterBar = me.$refs.filterBar;
      let dateFilter = me.$refs.filterBar.parsedFilters[0];
      let period = dateFilter
        .fn(dateFilter.value, dateFilter, filterBar)
        .value.split(",");
      let fromDate = period[0].split(/-|\s|:/);
      let endDate = period[1].split(/-|\s|:/);
      fromDate[1]--;
      endDate[1]--;
      fromDate = new Date(...fromDate).getTime();
      endDate = new Date(...endDate).getTime();
      me.$loading({
        url: "/api/sale/sale/enterprise/businessChance",
        params: {
          keyword,
          fromDate,
          endDate,
          pageNumber: number,
          pageSize: 20,
          quoted: 0,
          page: number,
          start: 0,
          limit: 20,
        },
      }).then(function (res) {
        callback && callback.call(me);
        if (res.success) {
          if (next) {
            if (res.data.list.length) {
              me.params.number = number;
              me.items = me.items.concat(res.data.list);
            }
          } else {
            me.params.number = 1;
            me.items = res.data.list;
          }
        } else {
          me.$router.push({
            name: "Error",
            params: res
          });
        }
      });
    },
    gotoView(item) {
      if (item.quId) {
        this.$router.push("/sale/quote/" + item.quId);
      } else {
        this.$router.push({
          name: "SaleBusinessChance",
          params: {
            initData: Object.assign({}, item),
          }
        });
      }
    },
  },
};
</script>